import { useContext, useEffect } from 'react'
import { useRootStore } from '@/contexts/root-store-context'
import { DocumentTitleContext } from '@/components/DocumentTitleProvider'

/**
 * Sets the document title.
 */
export function useDocumentTitle(title: string | null | undefined) {
  const {
    shell: {
      shellInfo: { name: workspaceName },
    },
  } = useRootStore()

  const { set } = useContext(DocumentTitleContext)

  useEffect(() => {
    set(title ? `${title} — ${workspaceName}` : workspaceName)
    return () => {
      set(workspaceName)
    }
  }, [title, workspaceName, set])
}
